// eslint-disable-next-line
import * as React from 'react';
import './BpiView.css'
import BpiViewNavBar from './components/BpiViewNavBar';
import BpiViewPageHeader from './components/BpiViewPageHeader';
import { Redirect, Route, RouteComponentProps, Switch } from 'react-router';
import BpiSummaryView from './BpiSummaryView';
import BpiDetailsView from './BpiDetailsView';
import { ApplicationState } from '../../store';
import * as BpiReducer from '../../store/BpiReducer';
import * as MessageReducer from '../../store/MessageReducer';
import { ConnectedProps, connect } from 'react-redux';
import { getCategories } from '../../services/BpiService';

// ------------------------------------------------------------------------------------------------
// component

const connector = connect(
    (state: ApplicationState) => { return { bpiState: state.bpiState, messageState: state.messageState } },
    { ...BpiReducer.actionCreators, ...MessageReducer.actionCreators }
);

type PropsFromRedux = ConnectedProps<typeof connector>

type Props = PropsFromRedux & {
}

type State = {}

class BpiView extends React.Component<Props & RouteComponentProps, State> {

    private working: boolean = false;
    scrollRef: React.RefObject<HTMLDivElement>;

    constructor(props: Props & RouteComponentProps) {
        super(props);
        this.scrollRef = React.createRef();
    }

    // --------------------------------------------------------------------------------------------
    // lifecycle

    componentDidMount() {
        document.title = 'Building Product Information | Steel&Tube';
        this.loadCategoriesData();
    }

    scrollOnHashChange() {
        const { hash } = this.props.location;
        if (hash) {
            const element = this.scrollRef.current;
            if (element) {
                const targetElement = element.querySelector(hash);
                if (targetElement) {
                    targetElement.scrollIntoView({ behavior: 'smooth' });
                }
            }
        }
    }

    // --------------------------------------------------------------------------------------------
    // data

    loadCategoriesData = () => {
        if (this.working) {
            return;
        }

        // load
        this.working = true;
        getCategories()
            .then(response => {
                this.working = false;

                if (!response.success) {
                    alert(response.errorMessage);
                }
                else {
                    this.props.setCategories(response.data);
                    this.scrollOnHashChange();
                }
            })
            .catch(error => {
                this.working = false;
                alert(error);
            });
    }


    // --------------------------------------------------------------------------------------------
    // render

    public render() {
        return (
            <div className='bpi-view' ref={this.scrollRef}>
                <BpiViewNavBar />
                <div className='bpi-view-divider' />

                <div className='bpi-view-body'>
                    <BpiViewPageHeader categories={this.props.bpiState.categories} />
                    <Switch>
                        <Route exact path="/bpi/:code" component={BpiDetailsView} />
                        <Route exact path="/bpi" component={BpiSummaryView} />
                        <Route render={() => <Redirect to="/bpi" />} />
                    </Switch>
                </div>

                <div className='bpi-view-footer-divider'></div>
                <div className='bpi-view-footer'>
                    <div className='bpi-view-footer-content'>
                        Copyright © {new Date().getFullYear()} Steel & Tube Holdings Ltd.
                        <span>
                            <a href="https://steelandtube.co.nz/corporate/terms-and-conditions">Terms of trade</a>
                        </span>

                        <span>
                            <a href="https://steelandtube.co.nz/corporate/terms-use">Website terms</a>
                        </span>
                    </div>
                </div>

            </div>
        )
    };
};

export default connector(BpiView);